/* Maribelle Mode — minimal theme JS */
(function () {
  'use strict';

  // Smooth-scroll for in-page anchors
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href^="#"]');
    if (!link) return;
    var href = link.getAttribute('href');
    if (href === '#' || href.length < 2) return;
    var target = document.querySelector(href);
    if (!target) return;
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });

  // Brand carousel
  function initBrandCarousel(root) {
    var track = root.querySelector('[data-brand-track]');
    var slides = root.querySelectorAll('[data-brand-slide]');
    var prev = root.querySelector('[data-brand-prev]');
    var next = root.querySelector('[data-brand-next]');
    if (!track || !slides.length) return;

    var total = slides.length;
    var index = 0;

    function update() {
      track.style.transform = 'translateX(' + (-100 * index) + '%)';
      if (prev) prev.disabled = index === 0;
      if (next) next.disabled = index >= total - 1;
    }

    function go(delta) {
      index = Math.max(0, Math.min(total - 1, index + delta));
      update();
    }

    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });

    // Touch / swipe
    var startX = null;
    track.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 40) go(dx > 0 ? -1 : 1);
      startX = null;
    });

    // Auto-rotate every 6s, pause on hover
    var timer = null;
    function start() {
      if (total <= 1) return;
      timer = setInterval(function () {
        index = (index + 1) % total;
        update();
      }, 6000);
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);

    update();
    start();
  }
  document.querySelectorAll('[data-brand-carousel]').forEach(initBrandCarousel);

  // Reveal on scroll (subtle fade-in for sections)
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });
    document.querySelectorAll('section').forEach(function (el) {
      el.classList.add('section--reveal');
      io.observe(el);
    });
  }
})();
